import { component as defineComponent } from 'flightjs';
import withButtonStates from 'entry/mixins/with-button-states';

function actions() {
    this.attributes({
        eliminate: '[data-eliminate-button]',
        uneliminate: '[data-uneliminate-button]',
        withdraw: '[data-withdraw-button]',
        unwithdraw: '[data-unwithdraw-button]',
        delete: '[data-delete-button]',
        restore: '[data-restore-button]',
        award: '[data-award-button]',
        report: '[data-report-button]',
    });

    this.updateActionsState = function(e, entry) {
        var permissions = entry._embedded.permission;
        var entryActions = {
            eliminate: !entry.is_eliminated && permissions.canEliminate,
            uneliminate: entry.is_eliminated && permissions.canUneliminate,
            withdraw: !entry.is_withdrawn && permissions.canWithdraw,
            unwithdraw: entry.is_withdrawn && permissions.canUnwithdraw,
            award: !entry.is_winner && permissions.canAward,
            delete: !entry.is_deleted && permissions.canDelete,
            restore: entry.is_deleted && permissions.canRestore,
        };

        Object.keys(entryActions).forEach(
            function(action) {
                if (entryActions[action]) {
                    this.enableButton(action);
                } else {
                    this.disableButton(action);
                }
            }.bind(this)
        );
    };

    this.isDisabled = function(button) {
        return button.is('[data-disabled]') && button.data('disabled') !== false;
    };

    // --------------------------------------------------
    // Action triggers
    // --------------------------------------------------

    this.triggerEliminate = function() {
        if (!this.isDisabled(this.select('eliminate'))) {
            this.triggerActionEvent('eliminate', 'uiEliminateEntryRequested');
        }
    };

    this.triggerUneliminate = function() {
        if (!this.isDisabled(this.select('uneliminate'))) {
            this.triggerActionEvent('uneliminate', 'uiUneliminateEntryRequested');
        }
    };

    this.triggerDelete = function() {
        if (!this.isDisabled(this.select('delete'))) {
            this.triggerActionEvent('delete', 'uiDeleteEntryRequested');
        }
    };

    this.triggerRestore = function() {
        if (!this.isDisabled(this.select('restore'))) {
            this.triggerActionEvent('restore', 'uiRestoreEntryRequested');
        }
    };

    this.triggerWithdraw = function() {
        if (!this.isDisabled(this.select('withdraw'))) {
            this.triggerActionEvent('withdraw', 'uiWithdrawEntryRequested');
        }
    };

    this.triggerUnwithdraw = function() {
        if (!this.isDisabled(this.select('unwithdraw'))) {
            this.triggerActionEvent('unwithdraw', 'uiUnwithdrawEntryRequested');
        }
    };

    this.triggerShowReport = function() {
        if (!this.isDisabled(this.select('report'))) {
            this.triggerActionEvent('report', 'uiShowReportFormRequested');
        }
    };

    // --------------------------------------------------
    // Actions
    // --------------------------------------------------

    this.eliminate = function() {
        this.switchButtons('uneliminate', 'eliminate');
    };

    this.uneliminate = function() {
        this.switchButtons('eliminate', 'uneliminate');
    };

    this.withdraw = function() {
        this.switchButtons('unwithdraw', 'withdraw');
    };

    this.unwithdraw = function() {
        this.switchButtons('withdraw', 'unwithdraw');
    };

    this.delete = function() {
        this.switchButtons('restore', 'delete');
    };

    this.restore = function() {
        this.switchButtons('delete', 'restore');
    };

    this.after('initialize', function() {
        this.on('click', {
            eliminate: this.triggerEliminate,
            uneliminate: this.triggerUneliminate,
            delete: this.triggerDelete,
            restore: this.triggerRestore,
            withdraw: this.triggerWithdraw,
            unwithdraw: this.triggerUnwithdraw,
            award: this.award,
            report: this.triggerShowReport,
        });

        this.on('dataEntryUpdated', this.updateActionsState);

        // deal with failures
        this.on('dataEntryEliminatedFailed', this.uneliminate);
        this.on('dataEntryUneliminatedFailed', this.eliminate);

        this.on('dataEntryWithdrawnFailed', this.unwithdraw);
        this.on('dataEntryUnwithdrawnFailed', this.withdraw);

        this.on('dataEntryDeletedFailed', this.restore);
        this.on('dataEntryRestoredFailed', this.delete);

        // Show immediate feedback for these actions.
        this.on('uiEliminateEntryRequested', this.eliminate);
        this.on('uiUneliminateEntryRequested', this.uneliminate);

        this.on('uiWithdrawEntryRequested', this.withdraw);
        this.on('uiUnwithdrawEntryRequested', this.unwithdraw);

        this.on('uiDeleteEntryRequested', this.delete);
        this.on('uiRestoreEntryRequested', this.restore);
    });
}

export default defineComponent(actions, withButtonStates);



// WEBPACK FOOTER //
// ./src/web/js/entry/ui/actions.js